<template>
  <div id="detail" v-loading="loading">
    <el-row v-if="detail">
      <!--书本信息-->
      <el-col :offset="2" :span="20">
        <div style="display: flex">
          <div class="content">
            <img v-lazyload src="../../static/loading.svg" :data-src="detail.cover" data-err="../../static/df.png" class="icon"/>
          </div>
          <div style="flex: 1" class="content">
            <h2 style="margin-top:10px;margin-bottom:8px;color:#606266">
              {{detail.title}}
            </h2>
            <p class="type">{{detail.city}}</p>
            <p>详细地址：{{detail.addr| kong}}</p>

            <p style="color:#E6A23C;font-size: 14px;" v-if="detail.value != 0">
              获得打赏：
              {{detail.valueNas}}nas
            </p>

            <p>
              <span style="float: left">推荐指数：</span>
              <el-rate
                style="float: left"
                disabled
                v-model="detail.score"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
              </el-rate>
            </p>


          </div>
        </div>
      </el-col>

      <el-col :offset="2" :span="20">
        <br>
      </el-col>

      <el-col :offset="2" :span="20" style="background-color:#f3f3f3;padding:10px;border-radius:4px;border: 1px solid #888">
        <el-row>
          <el-col :span="24" style="text-align: center;background-color: white;padding: 2px;border-radius:4px;">
            <img src="../../static/sheqianping.png" style="width: 100px;height:40px;"/>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="show-content">
            <p v-html="detail.content" style="padding: 10px;color:#606266;font-size: 16px;letter-spacing: 2px;font-weight: 500;">
            </p>
          </el-col>
        </el-row>
        <br>
      </el-col>

      <el-col :offset="2" :span="20">
        <br>
      </el-col>

      <!--其他人评论-->
      <el-col :offset="2" :span="20">
        <h3>评论</h3>
      </el-col>
      <el-col :offset="2" :span="20" v-for="(item, k) in detail.comments" :key="k" style="padding-top:10px;padding-bottom:10px;border-top:1px solid #E4E7ED">
        <div style="float: left; height: 35px; line-height: 35px">
          <vue-letter-avatar :name='item.nickname' size='30' :rounded='true' />&nbsp;
        </div>
        <div style="height: 35px;line-height: 35px"  class="post_meta_top">
          <div style="float: left">
            {{item.nickname}} - {{item.ctDes}}
          </div>

          <div style="float: left;">
            <span style="float: left;">&nbsp;&nbsp;打分：</span>
            <el-rate
              style="float: left;margin-top:7px;"
              disabled
              v-model="item.score"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
            </el-rate>
          </div>

          <div v-if="item.value != 0" style="float:left;color:#E6A23C;">
            <span style="float: left;">&nbsp;&nbsp;打赏：</span>
            {{item.valueNas}} Nas
          </div>

        </div>
        <p class="post_content">{{item.content}}</p>
      </el-col>

      <!--我发布评论-->
      <el-col :offset="2" :span="20">
        <el-form :model="subform" ref="subform" :rules="subformRules">
          <el-form-item label="我的评论" prop="comment">
            <el-input type="textarea" minlength="1" maxlength="150"
                      v-model="subform.comment" auto-complete="off"
                      :autosize="{ minRows: 6, maxRows: 6}"></el-input>
          </el-form-item>

          <el-form-item label="我的昵称" prop="nikename">
            <el-input minlength="1" maxlength="50" v-model="subform.nikename"></el-input>
          </el-form-item>

          <el-form-item label="我的打分" prop="score">
            <div style="margin-top:10px;">
              <el-rate
                v-model="subform.score"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
              </el-rate>
            </div>
          </el-form-item>

          <el-form-item label="我的打赏" prop="score">
            <el-input type="number" v-model="subform.reward" auto-complete="off">
              <template slot="append">Nas</template>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="subMyComment(detail.id)">提交评论</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'
import nebulas from 'nebulas'

export default {
  data () {
    return {
      loading: false,
      subformTile: '',
      queryId: null,
      subform: {
        comment: '',
        nikename: '吃货路人甲',
        reward: 0,
        score: 0
      },
      subformRules: {
        comment: [
          {required: true, message: '请输入评论', trigger: 'blur'},
          {min: 1, max: 150, message: '长度在 1 到 150 个字符', trigger: 'blur'}
        ],
        nikename: [
          {required: true, message: '请输入昵称', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
        ],
        score: [
          {required: true, message: '请打分', trigger: 'blur'}
        ]
      },
      detail: null
    }
  },
  methods: {
    getDetail: function (id) {
      let vueThis = this;
      vueThis.loading = true;
      console.log('getDetail', id)
      vueThis.$store.dispatch('simulateCallNew', {funcName: 'getFoodInfo', params: [id]}).then((ret) => {
        let data = JSON.parse(ret);
        vueThis.detail = data;
        let d = new Date(vueThis.detail.ct)
        vueThis.detail.ctDes = d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
        vueThis.detail.valueNas = nebulas.Unit.fromBasic(vueThis.detail.value, 'nas');
        vueThis.detail.valueNas = _.replace(vueThis.detail.valueNas, '"', '');

        _.forEach(vueThis.detail.comments, function (item) {
          let d = new Date(item.ct)
          item.ctDes = d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
          item.valueNas = nebulas.Unit.fromBasic(item.value, 'nas');
          item.valueNas = _.replace(item.valueNas, '"', '');
        });
        vueThis.loading = false;
      }, (error) => {
        vueThis.loading = false;
        vueThis.showErr('获取详情失败' + error);
      });
    },
    // 评论
    subMyComment: function (id) {
      let vueThis = this
      if (_.isEmpty(vueThis.accounts)) {
        vueThis.showErr('请先登录钱包！');
        return false;
      }
      vueThis.$refs['subform'].validate((valid) => {
        if (valid) {
          let f = vueThis.subform;
          let params = [id + '', f.nikename + '', f.score + '', f.comment + ''];
          vueThis.loading = true;
          vueThis.$store.dispatch('callNew', {money: f.reward, funcName: 'addComment', params: params, goods: {name: '评论'}}).then((ret) => {
            vueThis.loading = false;
            console.log('评论成功', ret);
            vueThis.showSuccess('评论成功, 3秒后自动刷新页面');
            _.delay(function () {
              vueThis.subform.comment = '';
              vueThis.subform.reward = 0;
              vueThis.subform.score = 0;
              vueThis.getDetail(vueThis.queryId);
            }, 3000)
          }, (error) => {
            console.log('评论失败', error);
            vueThis.loading = false;
            vueThis.showErr('评论失败' + error);
          });
        } else {
          vueThis.showErr('请填写评论内容！');
        }
      })
    }
  },
  created () {
    this.queryId = this.$route.query.id;
    this.getDetail(this.queryId)
  },
  computed: mapState([
    'accounts'
  ])
}
</script>

<style>
  #detail {
  }

  #detail .post_content {
    padding: 10px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    line-height: 1.75;
    color: #757575;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #detail .post_meta_top{
    color: #666;
    font-size: 14px;
    font-style: italic;
  }

  #detail .icon{
    display: inline-block;
    float: left;
    width: 240px;
    height: 240px;
    border-radius:20px;
    object-fit: cover;
    box-shadow:0 4px 3px -2px rgba(0,0,0,.8), 0 0 3px 1px rgba(0,0,0,.05);
    transition:all .4s;
    vertical-align: middle;
    border-style: none;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  #detail .content{
    font-weight: 200;
    letter-spacing: 2px;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;;
  }

  #detail .content .type{
    color:  #999;
    font-size: 16px;
  }

  #detail .content p{
    margin-top:7px;
    margin-bottom:7px;
    color: #606266;
    font-size: 14px;
  }

  #detail .content p a{
    color: #409EFF;
  }

  #detail .show-content img{
    max-width: 100%;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/sub-detail.vue